import { Box, LinearProgress, createTheme, ThemeProvider } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import { configState } from "../lib/State";

const progressTheme = createTheme({
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: "15px",
          borderRadius: "10px",
          border: "2px solid white",
          background: "#e6e6e6",
        },
        bar: {
          borderRadius: "10px",
          background: "linear-gradient(to right, #fe1e11, #fe8217)",
        },
      },
    },
  },
});

function HomeCalorieGageBoostUp(props) {
  const { login } = props;
  const [calorie, setCalorie] = useState(0);
  const token = get_token();
  const cid = get_cid();

  const load_data = async () => {
    let result = await axios.post(configState.api + "/hr/get_kcal_loop", {
      token: token,
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    });
    setCalorie(result.data.amount);
  };
  useEffect(() => {
    load_data();
  }, []);

  return (
    <div className="py-[15px] w-full">
      <div className="flex justify-center items-center">
        <div className="w-[60%] relative">
          <div className="bottom-[80%] left-0 h-[150%] flex items-end justify-center w-full absolute">
            <div className="flex items-end w-[97%]">
              <img src="/img/flame.gif" alt="" width="100%" />
            </div>
          </div>
          <ThemeProvider theme={progressTheme}>
            <LinearProgress variant="determinate" value={calorie / 10} />
          </ThemeProvider>
        </div>

        <Box
          sx={{
            display: "flex",
            marginLeft: "10px",
            // color: 'white',
            fontFamily: "BebasNeue",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              fontSize: "20px",
            }}
          >
            {calorie}
          </Box>
          <Box sx={{ fontSize: "18px" }}>/</Box>
          <Box sx={{ fontSize: "18px" }}>1000kcal</Box>
        </Box>
      </div>
      <div className="flex justify-center items-end tracking-tight">
        <img src="/img/fire.svg" alt="" className="w-4 mr-1" />
        <p className="text-[12.5px] leading-none text-red-500 bg-clip-text font-bold">
          칼로리 부스트 업 이벤트 !{" "}
          <span className="text-zinc-700">4월 한달간 </span>
          <span className="text-[#0092a2]">칼로리포인트 두배 획득 찬스 !</span>
        </p>
      </div>
    </div>
  );
}

export default HomeCalorieGageBoostUp;
